// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore, serverTimestamp } from "firebase/firestore";


// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey: "AIzaSyBjTXCifH3XOI8PYEGzHY6eH_YAVBA6q0I",
    authDomain: "webair-website.firebaseapp.com",
    projectId: "webair-website",
    storageBucket: "webair-website.firebasestorage.app",
    messagingSenderId: "970202224914",
    appId: "1:970202224914:web:fd97025755ed857b0dbbcb",
    measurementId: "G-ZM0J4940YW"
  };

// Initialize Firebase
const app = initializeApp(firebaseConfig);

const auth = getAuth(app);

const projectFireStore = getFirestore(app);

// Firestore timestamp
const timestamp = serverTimestamp;


export { auth, projectFireStore, timestamp };
